import PostalCodeInput from '@/views/components/Selectors/PostalCodeInput';
import { CountrySelect, StateSelect } from '@/views/screens/common';
import { Col, Form, Row } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getCarrierSearchProgress } from '../../../../redux/common/CommonActions';
import { routeFileSelector } from '../../../../utilz/i18n';
import Button from '../../../components/Buttons/Button';
import FormInput from '../../../components/Inputs/FormInput';

const CarrierSearchForm = ({ formInstance, onSubmit, labelForTestId, modalTypeForTest }) => {
  const dispatch = useDispatch();
  let [form] = Form.useForm();
  if (formInstance) {
    form = formInstance;
  }
  const countryCode = Form.useWatch('countryCode', form);
  const handleSubmit = (data) => {
    const payload = {
      CountryCode: data?.countryCode,
      CarrierName: data?.CarrierName,
      CarrierScacCode: data?.CarrierScacCode,
      CarrierZip: data?.postalCode,
      PageIndex: 1,
      PageSize: 10,
    };
    dispatch(getCarrierSearchProgress(payload));
    if (onSubmit) {
      onSubmit(data);
    }
  };

  const handleZipDetails = (data) => {
    form.setFieldsValue({
      countryCode: data?.countryCode,
      stateCode: data?.state,
      city: data?.city,
      postalCode: data?.zip,
    });
  };

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <Form form={form} onFinish={handleSubmit} initialValues={{ countryCode: 'US' }}>
      <Row gutter={15}>
        <Col md={8}>
          <FormInput
            name="CarrierName"
            label={t('translation:default.fields.companyName.label')}
            placeholder={t('translation:default.fields.companyName.placeholder')}
            editMode
          />
        </Col>
        <Col md={8}>
          <FormInput
            name="CarrierScacCode"
            label={t('translation:default.fields.scac.label')}
            placeholder={t('translation:default.fields.scac.placeholder')}
            editMode
          />
        </Col>
        <Col md={8}>
          <CountrySelect name="countryCode" />
        </Col>
        <Col md={8}>
          <PostalCodeInput
            name="postalCode"
            label={t('translation:default.fields.postalCode.label')}
            placeholder={t('translation:default.fields.postalCode.placeholder')}
            editMode
            handleZipDetails={handleZipDetails}
            countryCode={countryCode}
            labelForTestId={labelForTestId}
          />
        </Col>
        <Col md={8}>
          <StateSelect editMode={false} name="stateCode" countryCode={countryCode} />
        </Col>
        <Col md={8}>
          <FormInput label={t('translation:default.fields.city.label')} editMode={false} name="city" />
        </Col>
      </Row>
      <Row justify="end" gutter={15}>
        <Col>
          <Button buttonType="submit" data-testid={`${labelForTestId}-${modalTypeForTest}-search`}>
            {t('translation:default.buttons.search')}
          </Button>
        </Col>
        <Col>
          <Button
            onClick={() => form.resetFields()}
            type="default"
            data-testid={`${labelForTestId}-${modalTypeForTest}-clear`}
          >
            {t('translation:default.buttons.clear')}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default CarrierSearchForm;
